<template>
    <v-form ref="form" v-model="valid">
        <v-container>
            <v-row>
                <v-col v-if="thumbSaved" class="text-center border" cols="12">
                    <label>Thumbnail:</label>
                    <div class="thumbnail-display">
                        <a :href="`/storage/hotels${thumbSaved}`" class="thumbnail">
                        <v-img
                            contain
                            :src="`/storage/hotels${thumbSaved}`"/>
                        </a>
                        <v-btn class="mt-2" color="red" outlined @click="thumbSaved = null">
                            Trocar Thumbnail
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col v-else cols="12">
                    <label>Imagem Principal do Hotel:</label>
                    <file-input
                        compress
                        :compress-factor-breakpoints="[0.5, 2.5]"
                        :maxFilesAllowed="1"
                            v-model="thumb"
                        label="Adicione aqui a thumbnail"/>
                    <div v-if="hasValidated && !thumb" class="v-messages theme--light error--text mt-1" role="alert">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">A Thumbnail é obrigatória</div>
                        </div>
                    </div>
                </v-col>
                <v-col v-if="imagesSaved && imagesSaved.length" class="text-center border" cols="12">
                    <label>Outras Imagens:</label>
                    <div class="other-images-display">
                        <a v-for="hotelImage in imagesSaved" class="other-image" target="_blank" :href="`/storage/hotels${hotelImage}`">
                            <v-img
                                contain
                                :src="`/storage/hotels${hotelImage}`"/>
                        </a>
                    </div>
                    <v-btn class="mt-2" color="red" outlined @click="imagesSaved = null">
                        Trocar Outras Imagens
                        <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                </v-col>
                <v-col v-else cols="12">
                    <label>Outras Imagens:</label>
                    <file-input
                        compress
                        :compress-factor-breakpoints="[0.5, 2.5]"
                        :maxFilesAllowed="5"
                        v-model="images"
                        label="Adicione aqui as imagens adicionais"/>
                </v-col>

                <v-col v-if="agreementImageSaved" class="text-center border" cols="12">
                    <label>Print do Acordo:</label>
                    <div class="thumbnail-display">
                        <a :href="`/storage/hotels${agreementImageSaved}`" class="thumbnail">
                            <v-img
                                contain
                                :src="`/storage/hotels${agreementImageSaved}`"/>
                        </a>
                        <v-btn class="mt-2" color="red" outlined @click="clearAgreementImage">
                            Trocar Print do Acordo
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col v-if="!agreementImageSaved && !ownerCreationForm" cols="12">
                    <label>Print do Acordo:</label>
                    <file-input
                        compress
                        :compress-factor-breakpoints="[0.5, 2.5]"
                        :maxFilesAllowed="1"
                        v-model="agreementImage"
                        label="Adicione aqui o print do acordo com o hotel."
                    />
                </v-col>

            </v-row>
            <v-row v-if="!isApproveForm">
                <v-col cols="12" md="6" offset-md="3">
                    <v-btn
                        depressed
                        color="success"
                        @click="validate"
                        class="w-100"
                    >
                        Finalizar
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-else class="border mt-6">
                <v-col cols="12" class="text-center">
                    <label>Aprovar novo hotel?</label>
                </v-col>
                <v-col cols="12" md="6">
                    <v-btn
                        depressed
                        color="success"
                        @click="modalApprove"
                        class="w-100"
                    >
                        Aprovar
                    </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                    <v-btn
                        depressed
                        color="error"
                        @click="modalDeleteHotel"
                        class="w-100"
                    >
                        Reprovar
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <confirm-deletion-modal
            :dialog-active="deleteModalActive"
            :dialog-loading="deleteModalLoading"
            :entity-to-delete="hotelName"
            @close-dialog="modalDeleteHotel"
            @delete-method="deleteHotel"
        />
        <confirm-hotel-modal
            :dialog-active="confirmApproveDialog"
            :hotel-name="hotelName"
            @close-dialog="modalApprove"
            @approve-method="approveHotel"
        />
        <response-modal
            :show-dialog="dialogResponseShow"
            :type="dialogResponseType"
            :message="dialogResponseMessage"
            @close="closeModalResponse"
        />
    </v-form>
</template>

<script>
import FileInput from "../../FileInput.vue";
import ConfirmDeletionModal from "../../Modals/ConfirmDeletionModal.vue";
import ConfirmHotelModal from "../../Modals/ConfirmHotelModal.vue";
import ResponseModal from "../../Modals/ResponseModal.vue";
export default {
    name: "Images",
    components: {ResponseModal, ConfirmHotelModal, ConfirmDeletionModal, FileInput},
    props: {
        hotelThumb: {
            type: String,
            default: null
        },
        hotelImages: {
            type: Array,
            default: null
        },
        hotelAgreementImage: {
            type: String,
            default: null
        },
        hotelName: null
    },
    inject: ['ownerCreationForm'],
    data: () => ({
        valid: false,
        hasValidated: false,
        thumb: null,
        thumbSaved: null,
        images: [],
        imagesSaved: null,
        agreementImage: null,
        agreementImageSaved: null,
        deleteModalActive: false,
        deleteModalLoading: false,
        confirmApproveDialog: false,
        dialogResponseShow: false,
        dialogResponseMessage: '',
        dialogResponseType: ''
    }),
    computed: {
        isApproveForm() {
            return this.$route.query.approveForm;
        }
    },
    mounted() {
        this.thumbSaved = this.hotelThumb;
        this.imagesSaved = this.hotelImages;
        this.agreementImageSaved = this.hotelAgreementImage;
    },
    methods: {
        clearAgreementImage() {
            this.agreementImageSaved = null;
            this.agreementImage = null;
        },
        validate() {
            this.hasValidated = true;
            this.$refs.form.validate();
            if (this.valid && (this.thumbSaved || this.thumb)) {
                this.$emit('finish');
            }
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async getData() {
            const data = {
                thumb: this.thumbSaved ? null : this.thumb ? await this.toBase64(this.thumb[0]) : null,
                images: this.imagesSaved && this.imagesSaved.length ? null : await Promise.all(this.images.map(async img => {
                    return this.toBase64(img)
                })),
                agreementImage: this.agreementImage ? await this.toBase64(this.agreementImage[0]) : null
            };
            return data;
        },
        modalDeleteHotel() {
            this.deleteModalActive = !this.deleteModalActive;
        },
        responseModal(type, message) {
            this.dialogResponseType = type;
            this.dialogResponseMessage = message;
            this.dialogResponseShow = true;
        },
        closeModalResponse() {
            this.dialogResponseShow = false;
            this.$router.push({name: 'hotelsApprove'});
        },
        deleteHotel() {
            this.deleteModalLoading = true;

            axios.delete(`/api/hotel/${this.$route.params.id}`)
                .then(res => {
                    this.deleteModalLoading = false;
                    this.deleteModalActive = false;
                    this.responseModal('success', 'Hotel deletado com sucesso!');
                })
                .catch(() => {
                this.deleteModalLoading = false;
                this.deleteModalActive = false;
                this.responseModal('error', 'Erro ao excluir hotel. Tente novamente.');
                });
        },
        modalApprove() {
            this.confirmApproveDialog = !this.confirmApproveDialog;
        },
        approveHotel() {
            this.confirmApproveDialog = false;
            this.validate()
        }
    }
}
</script>

<style scoped>
    .border {
        border: 1px solid rgba(0, 0, 0, .38);
        border-radius: 8px;
        margin-bottom: 1rem;
    }
    .thumbnail-display {
        margin: auto;
        width: 50%;
    }
    .thumbnail {
        max-width: 100%;
        max-height: 100%;
    }
    .other-images-display {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .other-image {
        margin: 1px;
        border: 1px solid rgba(0, 0, 0, .38);
        max-width: calc(20% - 2px);
        max-height: calc(20% - 2px);
    }
</style>
